import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

type LangkahObservasiPraktikKinerjaSectionProps = {
  className?: string
  title?: string
  steps: Array<{ title: string; description: string }>
}

export function LangkahObservasiPraktikKinerjaSection({
  className,
  title = 'Langkah-langkah:',
  steps,
}: LangkahObservasiPraktikKinerjaSectionProps) {
  return (
    <section
      className={clsx(
        'space-y-3  p-6 border rounded bg-white border-subdued',
        className
      )}
    >
      <Text variant="heading-sm" className="!text-black" as="h2">
        {title}
      </Text>
      <ol className="grid grid-cols-3 gap-4">
        {steps.map((step, index) => (
          <li key={index} className="flex flex-row gap-3">
            {index > 0 && (
              <Icon color="informational" className="">
                arrow_circle_right
              </Icon>
            )}
            <ObservasiStep
              key={step.title}
              title={step.title}
              description={step.description}
            />
          </li>
        ))}
      </ol>
    </section>
  )
}

interface ObservasiStepProps {
  title: string
  description: string
}

export function ObservasiStep({ title, description }: ObservasiStepProps) {
  return (
    <div className="flex-1 flex flex-row gap-3">
      <div className="max-w-full">
        <Text variant="action" className="!text-blue-60">
          {title}
        </Text>
        <Text variant="body">{description}</Text>
      </div>
    </div>
  )
}
